export const SHOW_REDIRECTING_TO = 'SHOW_REDIRECTING_TO';
export const HIDE_REDIRECTING_TO = 'HIDE_REDIRECTING_TO';
export const LOAD_REDIRECTING_TO_COUNT = 'LOAD_REDIRECTING_TO_COUNT';
export const SET_REDIRECTING_TO_COUNT = 'SET_REDIRECTING_TO_COUNT';
export const SET_REDIRECTING_TO_PUBLISH_YOUR_CV = 'SET_REDIRECTING_TO_PUBLISH_YOUR_CV';
export const INCREMENT_REDIRECTING_TO_COUNT = 'INCREMENT_REDIRECTING_TO_COUNT';
export const REDIRECT_REDIRECTING_TO = 'REDiRECT_REDIRECTING_TO';



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/actionTypes.js